import { render, staticRenderFns } from "./UcContractTypeBadge.yaml?vue&type=template&id=a46b9684&component"
import script from "./UcContractTypeBadge.yaml?vue&type=script&lang=ts&component"
export * from "./UcContractTypeBadge.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports